import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { withStyles } from 'theme/withStyles';
import CeLoan from 'offers/CeLoan';
import DemandDeposit from 'offers/DemandDeposit';
import OeLoan from 'offers/OeLoan';
import TermDeposit from 'offers/TermDeposit';

const styles = ({ palette, spacing }) => ({
  root: {
    background: palette.background,
    border: `1px solid ${palette.grey.light}`,
    borderRadius: spacing.unit,
    margin: [0, 'auto'],
    marginBottom: spacing.md,
    maxWidth: 440,
    padding: [11, 20, 18, 10],
    position: 'relative',
  },
});

const Offer = ({ classes, isInAllBundle, offerName, offerType }) => {
  const offerProps = {
    isInAllBundle,
    name: offerName,
  };
  return (
    <fieldset
      className={classnames('panel panel-primary offer', isInAllBundle ? undefined : classes.root)}
    >
      {(() => {
        switch (offerType) {
          case 'termdepositoffer':
            return <TermDeposit {...offerProps} />;
          case 'unsecuredclosedendloanoffer':
          case 'securedclosedendloanoffer':
            return <CeLoan {...offerProps} />;
          case 'unsecuredopenendloanoffer':
          case 'securedopenendloanoffer':
            return <OeLoan {...offerProps} />;
          case 'demanddepositoffer':
          default:
            return <DemandDeposit {...offerProps} />;
        }
      })()}
    </fieldset>
  );
};

Offer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  isInAllBundle: PropTypes.bool,
  offerName: PropTypes.string.isRequired,
  offerType: PropTypes.string.isRequired,
};

Offer.defaultProps = {
  isInAllBundle: false,
};

const mapStateToProps = ({ offers }, { offerName }) => ({
  offerType: offers[offerName]?.type.toLowerCase(),
});

const OfferStyled = withStyles(styles)(Offer);

export default connect(mapStateToProps)(OfferStyled);
